const month = (name, abbreviation, ordinal) => ({
    key: name.toLowerCase(),
    name,
    abbreviation,
    ordinal,
    days: 36,
    startingWeekday: 4,
    leapDays: null,
    intercalary: null,
    dayOffset: null,
});
const weekday = (name, abbreviation, ordinal) => ({
    key: name.toLowerCase(),
    name,
    abbreviation,
    ordinal,
    isRestDay: null,
});
const season = (name, startDay, monthStart, monthEnd) => ({
    key: name.toLowerCase(),
    name,
    abbreviation: null,
    startDay,
    foundry: { monthStart, monthEnd },
});
function deepFreeze(value) {
    if (typeof value === 'object' && value !== null) {
        for (const inner of Object.values(value))
            deepFreeze(inner);
        Object.freeze(value);
    }
    return value;
}
/**
 * The calendar example (1.0b deliverable 3), written by hand from the committed synthetic fixture
 * `packages/fixtures/calendar/vesk-almanac.calendar.json` through P0-13's import rules with
 * `seasonDayBase` 0: each key is the slug of its name; absent month and weekday options are null;
 * a season's `startDay` is its `dayStart`; the file's `id` and `system` go to `source.extras` by
 * JSON pointer; and the imported calendar's one era counts up with no name, suffix, start or end
 * and the anchor `{year: 0, eraYear: 0}`, so era years equal absolute years (1.K-1 deliverable 1).
 * Its leap rule is dormant (no month has `leapDays`). Frozen.
 */
export const EXAMPLE_CALENDAR = deepFreeze({
    name: 'Vesk Almanac',
    description: 'The reckoning kept by the Lantern Watch.',
    yearZero: 1000,
    firstWeekday: 4,
    leap: { start: 1004, interval: 4 },
    months: [
        month('Rime', 'Rim', 1),
        month('Thaw', 'Tha', 2),
        month('Sowing', 'Sow', 3),
        month('Bloom', 'Blo', 4),
        month('Highsun', 'Hig', 5),
        month('Reaping', 'Rea', 6),
        month('Ember', 'Emb', 7),
        month('Mist', 'Mis', 8),
        month('Gale', 'Gal', 9),
        month('Deep', 'Dee', 10),
    ],
    weekdays: [
        weekday('Lampday', 'Lam', 1),
        weekday('Tideday', 'Tid', 2),
        weekday('Saltday', 'Sal', 3),
        weekday('Bellday', 'Bel', 4),
        weekday('Reedday', 'Ree', 5),
        weekday('Stillday', 'Sti', 6),
    ],
    time: { hoursPerDay: 24, minutesPerHour: 60, secondsPerMinute: 60 },
    seasons: [
        season('Spring', 72, 3, 6),
        season('Summer', 180, 6, 8),
        season('Autumn', 270, 8, 10),
        season('Winter', 330, 10, 3),
    ],
    moons: [
        { key: 'oss', name: 'Oss', cycleLength: 29, offset: 3 },
        { key: 'pell', name: 'Pell', cycleLength: 47, offset: 0 },
    ],
    eras: [
        {
            key: 'default',
            name: '',
            suffix: '',
            direction: 'up',
            start: null,
            end: null,
            anchor: { year: 0, eraYear: 0 },
        },
    ],
    approx: { year: 5, decade: 1, month: 1, day: 3 },
    foundry: { worldTimeOffset: 0, seasonDayBase: 0 },
    source: {
        format: 'foundry-calendar-config',
        extras: { '/id': 'vesk-almanac', '/system': 'dnd5e' },
    },
});
//# sourceMappingURL=example-calendar.js.map